import React from 'react';
import paysafeLogo from '../../assets/paysafe-logo.png';
import callApi from '../../utils/callApi';
import qs from 'qs';
import { capitalize } from '../../utils/helpers';
import { PROMO_CODES } from '../../constants/promoCodes';
import { getCookie } from '../../utils/helpers';

import { VALIDATION_URL } from '../../constants/apiUrls/apiUrls';
import { PAYSAFE_COUNTRY_CODES, EMAIL_BE_VALIDATION } from '../../constants/processors';
import './PaysafeForm.css';

const OPTIONS = {
  environment: window.PAY_SAFE_ENVIRONMENT,
  // environment: 'TEST',
  fields: {
    cardNumber: {
      selector: "#card-number",
      placeholder: "Card number"
    },
    expiryDate: {
      selector: "#expiration-date",
      placeholder: "00 / 00"
    },
    cvv: {
      selector: "#cvv",
      placeholder: "000"
    },
  },
  style: {
    input: {
      "letter-spacing": "1px",
      "font-size": "14px"
    }
  }
};

class PaysafeForm extends React.Component {
    constructor(props) {
      super(props);
      this.paysafeInstance = null;

      function generateXsellsCheckedState () {
        const { activeProgram } = props;
        const xSells = activeProgram.categories[0].methods[0].xSells;
        const xSellsStateObj = {};
        xSells.forEach(xSell => { xSellsStateObj[xSell.id] = xSell.details.optional });
        return xSellsStateObj;
      }

      const xSells = this.props.activeProgram.categories[0].methods[0].xSells;

      this.state = xSells ? generateXsellsCheckedState() : {};
    }

    componentDidMount() {
      const { singleUseApiKey } = this.props;
      window.paysafe.fields.setup(singleUseApiKey, OPTIONS, (paysafeInstance, error) => {
        if (error) {
          console.error("Setup error: " + error.code + " " + error.detailedMessage);
        } else {
          this.paysafeInstance = paysafeInstance;
        }
      });
    }

    componentWillUnmount() {
      const { onDismount } = this.props;
      onDismount();
    }

    onXSellsChange = (e) => {
      this.setState({ [e.target.id]: e.target.checked });
    }

    BEValidate = (target, val) => {
      const data = {[target]: val};
      const url = VALIDATION_URL.replace('{object}', encodeURIComponent(target));
      return callApi(url, 'GET', data);
    }

    handleSubmit = (e) => {
      e.preventDefault();
      const { userPremiumExpired, anchorToSubscribe, isGuest, isGift } = this.props;
      const { onSubmit, clearErrors, email, addError, setPurchaseButtonDisabled } = this.props;
      setPurchaseButtonDisabled(true);
      clearErrors();
      if ((!this.props.createdUser && !userPremiumExpired && (!anchorToSubscribe && !isGift)) || (!userPremiumExpired && anchorToSubscribe && isGuest)) {
        this.BEValidate('email', email).then(res => {
          if (res && res.data && res.data.status) {
            
            switch (res.data.status) {
              case EMAIL_BE_VALIDATION.VALIDATION_OK:
                onSubmit(this.paysafeInstance, this.state);
                break;
              case EMAIL_BE_VALIDATION.ALREADY_IN_USE:
                addError('Email already in use');
                setPurchaseButtonDisabled(false);
                break;
              default:
                addError('Something went wrong, please try again later');
                setPurchaseButtonDisabled(false);
                break;
            }
          }
        });
      } else {
        onSubmit(this.paysafeInstance, this.state);
      }
    }

    displayErrors = (errors) => {
      return (
        <div className="gen-error">
          <div>
            Your transaction has failed.
          </div>
          { errors.map((error, index) => (
            <span key={index} className="paysafe-err-msg">{error}</span>
          ))}
        </div>
      )
    }

    displayProcessingMessage = () => (
      <div className="gen-msg">
        Processing ...
      </div>
    )

    displayStatusMessage = () => {
      const { errors, processing } = this.props;
      const showErrors = errors && errors.length > 0;
      return (
        <React.Fragment>
          { showErrors && this.displayErrors(errors) }
          { processing && this.displayProcessingMessage() }
        </React.Fragment>
      );
    }

    displayPrice = () => {
      const { amount, currency, details } = this.props.activeProgram;

      const curr = currency.symbol;
      if(!details){
        return (<h1>alsdadkjaklsdjla</h1>)
      }
      if ( details.trialUnit && details.trialPeriod) {
        const trialUnitSingle = details.trialUnit.substring(0, details.trialUnit.length - 1).toLowerCase();
        return (
          <h3 style={{color: '#7f7f7f'}}>
            {curr}{amount} - {details.trialPeriod} {details.trialPeriod>1 ? trialUnitSingle + 's' : trialUnitSingle} trial
          </h3>
        )
      } else {
        return (
          <h3 style={{color: '#7f7f7f'}}>
            {curr}{amount} - {details.recurringPeriod} {details.recurringPeriod>1 ? details.recurringPeriodType + 's' : details.recurringPeriodType} subscription
          </h3>
        )
      }
    }

    displayPayInfo = (program) => {
      const {
        amount,
        details: { trialPeriod, trialUnit, recurringAmount, recurringPeriod, recurringPeriodType },
        currency: { symbol } } = program;

      if (trialPeriod && trialUnit) {
        return <h5 style={{color: '#7f7f7f'}}>Free initially. Rebills {recurringPeriodType}ly at {symbol}{parseInt(recurringAmount)}</h5>;
      } else {
        if (amount && recurringAmount && amount != recurringAmount) {
          return <h5 style={{color: '#7f7f7f'}}>Billed {symbol}{amount} first {recurringPeriod > 1 ? recurringPeriod : ''} {recurringPeriod > 1 ? recurringPeriodType + 's' : recurringPeriodType}. Rebills {recurringPeriodType}ly at {symbol}{parseInt(recurringAmount)}</h5>;
        } else {
          return <h5 style={{color: '#7f7f7f'}}>Billed as one payment of {program.currency.symbol + program.amount}</h5>
        }
      }
    }

    displayXsellTarget = (target) => {
      switch (target) {
        case 'MRSKIN':
          return 'MR. SKIN';
        case 'PLAYBOY_PLUS':
          return 'Playboy Plus';
        default:
          return target;
      }
    }

    generateFreeXSellText = (xSell) => {
      const { currency } = xSell;
      const { trialPeriod, trialUnit, target, recurringAmount, recurringPeriodType } = xSell.details;
      const trialUnitSingle = trialUnit.substring(0, trialUnit.length - 1);

      return `Includes ${trialPeriod}-${trialUnitSingle} FREE trial to ${this.displayXsellTarget(target)}. Renews at ${currency.symbol}${parseFloat(recurringAmount)} per ${recurringPeriodType}. Cancel anytime.`
    }

    generateNonFreeXSellText = (xSell) => {
      return 'NON FREE'
    }

    displayXSellsInfo = (xSell) => {
      const { amount } = xSell;
      return (
        amount
        ? this.generateNonFreeXSellText(xSell)
        : this.generateFreeXSellText(xSell)
      )
    }

    renderXSells = () => {
      const { activeProgram } = this.props;
      const xSells = activeProgram.categories[0].methods[0].xSells;
      if (!xSells) return null;
      return (
        xSells.map((xSell) => {
          const xSellsId = xSell && xSell.id;
          const optional = xSell && xSell.details.optional;
          return (
            <div className="xsells" key={xSellsId}>
            {
              optional &&
              <input
                type="checkbox"
                id={xSell.id}
                checked={this.state[xSell.id]}
                onChange={this.onXSellsChange}
              />
            }
            {
              xSells &&
              <h6 style={{color: '#7f7f7f', display: 'inline'}}>
                {this.displayXSellsInfo(xSell)}
              </h6>
            }
            </div>
          )
        })
      )
    }

    render() {
      const { holderName, country, zip, email, handleFieldChange, handleCountryChange, close, activeProgram, disablePurchaseButton, userPremiumExpired, subscriptionPage, anchorToSubscribe, isGuest } = this.props;

      return (
        <form className="paysafe-win sm" onSubmit={this.handleSubmit}>
           <div className="paysafe-header paysafe">
              <div className="logo-wrap">
                 <img src={paysafeLogo} width="140" />
              </div>
              <button className="paysafe-close-button" onClick={close}>
                x
              </button>
           </div>
           <div className="paysafe-main">
             <div style={{textAlign: 'center', marginBottom: '30px'}}>
               {/* {this.displayPrice()}
               {this.displayPayInfo(activeProgram)} */}
             </div>
              {this.displayStatusMessage()}
              <div className="paysafe-form-wrap">
                 <div className="paysafe-form-sec">
                    <div className="row">
                       <div className="col-xs-12 col-sm-6">
                          <div className="paysafe-form-sec">
                             <label className="paysafe-form-label" htmlFor="card-number">Card Number</label>
                             <div id="card-number" className="paysafe-form-input iframe-input" />
                          </div>
                       </div>
                       <div className="col-xs-12 col-sm-3">
                          <div className="paysafe-form-sec">
                             <label className="paysafe-form-label" htmlFor="expiration-date">Expiration</label>
                             <div id="expiration-date" className="paysafe-form-input iframe-input" />
                          </div>
                       </div>
                       <div className="col-xs-12 col-sm-3">
                          <div className="paysafe-form-sec">
                             <label className="paysafe-form-label" htmlFor="cvv">CCV Number</label>
                             <div id="cvv" className="paysafe-form-input iframe-input" />
                          </div>
                       </div>
                    </div>
                 </div>
                 <h4>Card Holder Details</h4>
                 <div className="paysafe-form-sec">
                    <label className="paysafe-form-label" htmlFor="holderName">Full Name (As it appears on the card)</label>
                    <input
                      id="holderName"
                      name="holderName"
                      className="paysafe-form-input"
                      placeholder="Full Name"
                      onChange={handleFieldChange}
                      value={holderName}
                      required="required"
                    />
                 </div>
                 { ((!this.props.createdUser && !userPremiumExpired && !anchorToSubscribe && !this.props.isGift) || (!userPremiumExpired && anchorToSubscribe && isGuest)) &&
                   <div className="paysafe-form-sec">
                      <label className="paysafe-form-label" htmlFor="email">Email Address</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="paysafe-form-input"
                        placeholder="Email Address"
                        onChange={handleFieldChange}
                        value={email}
                        required="required"
                      />
                   </div>
                 }
                 <div className="row">
                    <div className="col-xs-12 col-sm-5">
                       <div className="paysafe-form-sec">
                          <label className="paysafe-form-label" htmlFor="zip">ZIP / Postal Code</label>
                          <input
                            id="zip"
                            name="zip"
                            className="paysafe-form-input"
                            placeholder="ZIP"
                            onChange={handleFieldChange}
                            value={zip}
                            required="required"
                          />
                       </div>
                    </div>
                    <div className="col-xs-12 col-sm-7">
                       <div className="paysafe-form-sec">
                          <label className="paysafe-form-label" htmlFor="country">Country</label>
                          <select value={country.value} className='paysafe-select' onChange={handleCountryChange} required style={{
                            backgroundColor: '#eeeeee',
                            border: '1px solid #b0b0bf',
                            borderRadius: 0,
                            height: '34px',
                            minHeight: '34px',
                            width: '100%',
                            margin: '5px 0',
                            paddingLeft: '16px',
                            position: 'relative'
                          }}>
                            <option value="" disabled selected style={{
                              width: '100%'
                            }}>Select country...</option>
                            {
                              PAYSAFE_COUNTRY_CODES.map(code => (
                                <option key={code.value} value={code.value} style={{width: '100%'}}>{code.label}</option>
                              ))
                            }
                          </select>
                       </div>
                    </div>
                 </div>

              </div>
              {!userPremiumExpired && this.renderXSells()}
           </div>
           <div className="base">
              <button className="paysafe-btn paysafe-btn-black" type="submit" disabled={disablePurchaseButton}>{subscriptionPage ? 'Update Details' : 'Complete Payment'}</button>
           </div>
        </form>
      );
    }
}
export default PaysafeForm;
